 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A1_COVER from '@/components/01_Cover'
 import LOVE_1 from '@/components/love_1'
 import A2_COPYRIGHT from '@/components/02_Copyright'
 import A3_FM_ACK from '@/components/03_Fm_ack'
 import A4_FM_BIG from '@/components/04_Fm_big'
 import A5_FM_HAPPY from '@/components/05_Fm_happy'
 import A6_CHAPTER01 from '@/components/06_chapter01'
 import A7_CHAPTER02 from '@/components/07_chapter02'
 import A8_CHAPTER03 from '@/components/08_chapter03'
 import A9_CHAPTER04 from '@/components/09_chapter04'
 import A0_CHAPTER05 from '@/components/10_chapter05'
 import A1_CHAPTER06 from '@/components/11_chapter06'
 import A2_CHAPTER07 from '@/components/12_chapter07'
 import A3_CHAPTER08 from '@/components/13_chapter08'
 import LOVE_2 from '@/components/love_2'
 import A3_GALLERY from '@/components/13_Gallery'
 import A4_FM_INDEX from '@/components/14_Fm_Index'
 import A6_BM_ABT_THE_AUTHOR from '@/components/16_Bm_abt_the_author'
 import A7_KEY from '@/components/17_key'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/01_Cover",
 			"name" : "01_Cover",
 			"component" : A1_COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/02_Copyright",
 			"name" : "02_Copyright",
 			"component" : A2_COPYRIGHT
 		},
 		{
 			"path" : "/03_Fm_ack",
 			"name" : "03_Fm_ack",
 			"component" : A3_FM_ACK
 		},
 		{
 			"path" : "/04_Fm_big",
 			"name" : "04_Fm_big",
 			"component" : A4_FM_BIG
 		},
 		{
 			"path" : "/05_Fm_happy",
 			"name" : "05_Fm_happy",
 			"component" : A5_FM_HAPPY
 		},
 		{
 			"path" : "/06_chapter01",
 			"name" : "06_chapter01",
 			"component" : A6_CHAPTER01
 		},
 		{
 			"path" : "/07_chapter02",
 			"name" : "07_chapter02",
 			"component" : A7_CHAPTER02
 		},
 		{
 			"path" : "/08_chapter03",
 			"name" : "08_chapter03",
 			"component" : A8_CHAPTER03
 		},
 		{
 			"path" : "/09_chapter04",
 			"name" : "09_chapter04",
 			"component" : A9_CHAPTER04
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js